export enum ServiceContractDefaultTypeOfBilling {
  SINGLE_PRICE = 'SINGLE_PRICE',
  SERVICE_PRICE = 'SERVICE_PRICE',
  ARTICLE_PRICE = 'ARTICLE_PRICE',
}
